import React, { useState, useEffect } from 'react';

import { withRouter } from '@atlassian/react-resource-router';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { getHealthcheck } from './getHealthcheck.tsx';
import type { Healthcheck } from './HealthcheckSuggestedActionLink.types.tsx';
import HealthcheckPageContents from './HealthcheckPageContents.tsx';

const LOG_LOCATION = 'applinks.extra-auth.healthcheck';

export const HealthcheckPage = (): React.JSX.Element => {
	const [healthcheck, setHealthcheck] = useState<Healthcheck | null>(null);

	useEffect(() => {
		getHealthcheck()
			.then((data) => {
				setHealthcheck(data);
			})
			.catch((err) => {
				log.safeErrorWithoutCustomerData(LOG_LOCATION, 'Failed to fetch healthcheck data', err);
				setHealthcheck(null);
			});
	}, []);

	return <HealthcheckPageContents healthcheck={healthcheck} />;
};

const HealthcheckPageConnected: {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<string, any>): React.JSX.Element;
	displayName: string;
} = withRouter(HealthcheckPage);

export default HealthcheckPageConnected;
